import React from 'react'
import PropTypes from 'prop-types'

const Header = ({ title }) => {
  return (
    <div className="text-TypeConstant bg-gradient-green">
      <h1 className="px-16 pb-32 pt-72 text-center type-40">{title}</h1>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string,
}

export default Header
